import { server } from '@/components/Server.js';
import { appNotification } from '@/components/AppNotification.js';

export const interval = {
    count: 0,
    list: [],
    make: function (func, delay) {
        const id = setInterval(func, delay);
        this.list[this.count] = id;
        this.count++;
        return id;
    },
    clearAll: function () {
        this.list.forEach(function (item) {
            clearInterval(item);
        });
        this.list = [];
        this.count = 0;
        server.pingIntervalTimerId = null;
        appNotification.intervalTimerId = null;
    }
};
